import React from 'react';
import { LogOut, Plus, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ user, onNewTask }) => {
  const { logout } = useAuth();

  return (
    <header className="dashboard-header">
      <div className="container">
        <div className="header-content">
          <div className="header-left">
            <div className="logo">
              <div className="bamboo-icon-small">
                <div className="bamboo-stalk-small"></div>
                <div className="bamboo-leaves-small">
                  <div className="leaf-small"></div>
                  <div className="leaf-small"></div>
                </div>
              </div>
              <h1>Bamboo Todo</h1>
            </div>
          </div>
          
          <div className="header-center">
            <h2>Welcome back, {user?.username}!</h2>
            <p>Let's organize your day with zen-like focus</p>
          </div>
          
          <div className="header-right">
            <button
              onClick={onNewTask}
              className="btn btn-primary new-task-btn"
            >
              <Plus size={16} />
              New Task
            </button>
            
            <div className="user-menu">
              <div className="user-info">
                <User size={16} />
                <span>{user?.username}</span>
              </div>
              <button
                onClick={logout}
                className="btn btn-secondary logout-btn"
                title="Logout"
              >
                <LogOut size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
